import type { SupabaseClient } from "@supabase/supabase-js";
import { duePhotos, photoFailed, photoUploaded } from "@/db/repository";
import { alsBlob } from "@/db/dexie";

const BUCKET = "item-photos";
const MAX_VERSUCHE = 8;

/**
 * Lädt wartende Bilder hoch. Der Pfad beginnt mit der family_id, sonst weist
 * die Storage-Policy den Upload ab.
 *
 * Getrennt vom Zeilen-Sync, weil Bilder anders sind: groß, einzeln, und ein
 * gescheiterter Upload darf den Rest nicht aufhalten.
 */
export async function uploadPendingPhotos(client: SupabaseClient): Promise<number> {
  const wartend = await duePhotos();
  let hochgeladen = 0;

  for (const eintrag of wartend) {
    if (eintrag.attempts >= MAX_VERSUCHE) continue;

    const pfad = `${eintrag.family_id}/${eintrag.item_id}/${eintrag.id}.jpg`;
    const { error } = await client.storage.from(BUCKET).upload(pfad, alsBlob(eintrag), {
      contentType: "image/jpeg",
      upsert: true,
    });

    if (error) {
      await photoFailed(eintrag.id, error.message);
      continue;
    }

    await photoUploaded(eintrag.id, eintrag.item_id, pfad);
    hochgeladen += 1;
  }

  return hochgeladen;
}

/**
 * Adresse zum Anzeigen. Die Ablage ist privat, deshalb eine signierte Adresse
 * mit einer Stunde Gültigkeit.
 */
export async function signedPhotoUrl(client: SupabaseClient, path: string): Promise<string | null> {
  const { data, error } = await client.storage.from(BUCKET).createSignedUrl(path, 3600);
  return error ? null : data.signedUrl;
}
